export const REPAIR_TICKETTYPES = [
  {
    id: '001',
    name: 'repair',
  },
  {
    id: '002',
    name: 'upliftment',
  },
];
export const INSTALL_TICKETTYPES = [
  {
    id: '001',
    name: 'install',
  },

  {
    id: '002',
    name: 'site survey',
  },
  {
    id: '003',
    name: 'pre opening visit',
  },
  {
    id: '004',
    name: 'opening visit',
  },
  {
    id: '005',
    name: 'other',
  },
];
